export const STATUS_INIT = 'netbox.status.init';
export const STATUS_GET = 'netbox.status.get';
export const STATUS_SEND = 'netbox.status.send';
